import "./TrackTable.css";
import React, {Component} from "react";
import IconButton from "@material-ui/core/IconButton/IconButton";
import {
  makeUrlImageFromAlbums,
  makeWaveformUrl,
  secondsToMMSS
} from '../../../utils'
import {Link} from "react-router-dom";
import {request} from "../../../api-client";
import SoundWave from "../../../assets/img/Letflow/sound-wave.png";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../Snackbar/GlobalSnackbar";
import localization from "../../../config/localization";
import GlobalConfirmationDialog from "../Dialog/GlobalConfirmationDialog";
import GlobalSoundBar from "../../../sound-bar/GlobalSoundBar";
import {getSignatureTime, homePathGenerator,} from "../../../api-client/core/authentication/utils";
import {Dialog, Tooltip, Typography} from "@material-ui/core";
import EventManager from "../../../utils/EventManager";
import events from "../../../utils/EventManager/events";
import GlobalAddToPlaylistDialog from "../AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import browserHistory from "../../../utils/browserHistory";
import {withStyles} from "@material-ui/core/styles";
import ErrorBoundary from "../ErrorBoundary";
import {isNullOrUndefined} from "util";
import noImage from "../../../assets/img/Letflow/no-image.jpg";
import {
  CloudDownload,
  Pause,
  PlayArrow as Play,
  PlaylistAdd,
  RemoveCircle,
  Star,
  StarBorder
} from "@material-ui/icons";
import AddToGlobalPlaylistDialog from "../AddToPlaylistDialog/AddToGlobalPlaylistDialog";
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";
import {ReactComponent as List} from "../SvgIcons/list.svg";
import AddToPlaylist from "../AddToPlaylist";

class TrackTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tracks: this.props.tracks.data || this.props.tracks,
      playing: null,
      type: this.props.type || "music",
      suggestions: [],
      expandedVersionsIndex: null,
      selectedTrack: null,
      showAddToGlobalPlaylistDialog: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ tracks: nextProps.tracks.data || nextProps.tracks, suggestions: [] }, () => {
      this.setSoundbarSongAsPlayingIfPresent();
      !this.props.hideSuggestions && this.fetchSuggestions();
    });
  }

  componentDidMount = () => {
    this.setState({innerWidth: window.innerWidth})
    this.trackPausedSubscription = GlobalSoundBar.trackPaused$().subscribe(this.handleTrackPausedViaSoundbar);
    this.trackStartedPlayingSubscription = GlobalSoundBar.trackStartedPlaying$().subscribe(this.handleTrackStartedPlayingInSoundbar);
    this.setSoundbarSongAsPlayingIfPresent();
    (!this.props.hideSuggestions || isNullOrUndefined(this.props.hideSuggestions)) && this.fetchSuggestions();

    window.addEventListener('resize', () => this.setState({innerWidth: window.innerWidth}))
  };

  fetchSuggestions = () => {
    // dont fetch if client is in smart_search screen
    if (this.props.match.path.includes("smart_search") || this.props.match.path.includes("public")) return;
   /* const tracks = this.state.tracks;
    const musics = tracks.filter(x => (x.type !== "voice" && x.type !== "contentCreation"));
    if (musics.length > 0) {
      const ids = musics.map(x => x.id);
      request.music.suggestions(ids, clientId).then(x => this.setState({ suggestions: x }));
    }*/
  };

  setSoundbarSongAsPlayingIfPresent = () => {
    if (!GlobalSoundBar.isPlaying()) {
      return;
    }

    const alreadyPlayingTrackInSoundbar = this.state.tracks.find(track =>
      GlobalSoundBar.currentTrackIsTitled(track.title)
    );

    if (alreadyPlayingTrackInSoundbar) {
      this.setState({ playing: alreadyPlayingTrackInSoundbar.id });
    }
  };

  handleTrackPausedViaSoundbar = () => {
    const { tracks } = this.state;
    const pausableTrackFromOwnTracks = tracks.find(track => GlobalSoundBar.currentTrackIsTitled(track.title));

    if (pausableTrackFromOwnTracks) {
      this.setState({ playing: null });
    }
  };

  handleTrackStartedPlayingInSoundbar = () => {
    const { tracks } = this.state;
    const playableTrackFromOwnTracks = tracks.find(track => GlobalSoundBar.currentTrackIsTitled(track.title));

    if (playableTrackFromOwnTracks) {
      this.setState({ playing: playableTrackFromOwnTracks.id });
    } else {
      this.setState({ playing: null });
    }
  };

  componentWillUnmount = () => {
    this.trackPausedSubscription.unsubscribe();
    this.trackStartedPlayingSubscription.unsubscribe();
    window.removeEventListener('resize', () => this.setState({innerWidth: window.innerWidth}))
  };

  makeSoundbarTrackImage = (track) => makeImageUrlWithSize(track.image ? track : this.props.trackContainer, 'xs');

  handlePlayButtonPress = (track) => {
    const { tracks } = this.state;

    const soundbarCompatibleTracks = tracks.map(track => {
      return {
        fetchAudioUrl: () => new Promise(resolve => {
          let url = '';
          const date = new Date()
          const now_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

          if((now_utc - Date.parse(track.time)) < getSignatureTime()) {
            url = track.audio.url
          }else{
            url = request.contentCreation.get(track.id).then(track => track.audio.url)
          }

          resolve(url);
        }),
        id: track.id,
        title: track.title,
        subtitle: track.subtitle,
        image: this.makeSoundbarTrackImage(track),
        waveform: makeWaveformUrl(track),
        isFavorite: track.favorite,
        onToggleFavorite: undefined,
        //onDownload: () => this.openDownloadDialog(track),
        // onTitleClick: !this.trackIsAVoice(track) && !this.trackIsAContentCreation(track) ? () => this.props.history.push(getActiveChannel() ? channelPathGenerator(`musica/${track.id}-${slugify(track.title || track.name)}`) : homePathGenerator(`music/${track.id}`)) : undefined,
        onSubtitleClick: () => this.handleTrackContainerPressedInSoundbar(track),
      };
    });

    const playableTrackIndex = tracks.indexOf(track);

    this.setState({ playing: track.id });

    GlobalSoundBar.loadTracksAndPlay(soundbarCompatibleTracks, playableTrackIndex);
  };

  openDownloadDialog = (track) => {
    GlobalConfirmationDialog.show({
      title: localization.get("download.demo"),
      content: localization.get("download.demo.content"),
      request: () => this.handleDownload(track),
      confirmationLabel: localization.get("download"),
    });
  };

  handleDownload = (track) => {
    this.setState({ downloading: true });

    let type = "contentCreation"
    let downloadType = "download"

    return request[type][downloadType](track.id, {
      title: track.title,
      image: this.makeSoundbarTrackImage(track),
    })
      .then(e => {
        this.setState({ downloading: false });
      })
      .catch(() => {
        this.setState({ downloading: false });
      });
  };

  openAddToPlaylistDialog = track => {
    GlobalAddToPlaylistDialog.show({
      type: track.type || this.props.type || this.state.type,
      selectedTrack: track,
    });
  };

  openAddToGlobalPlaylistDialog = () => {
    return(
      <AddToGlobalPlaylistDialog
        selectedTrack={this.state.selectedTrack}
        show={this.state.showAddToGlobalPlaylistDialog}
        handleClose={() => this.setState({showAddToGlobalPlaylistDialog: false})}
      />
    )}

  handleTrackContainerPressedInSoundbar = (track) => {
    let destinationPath = this.makeTrackContainerPathFrom(track);

    if (destinationPath) {
      this.props.history.push(destinationPath);
    }
  };

  makeTrackContainerPathFrom = (track) => homePathGenerator("contenido/" + track.contentCreator.id + "-" + track.contentCreator.name)

  handlePauseButtonPress = () => {
    this.setState({ playing: null });
    GlobalSoundBar.pause();
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  addToFavorites = id => {
    const track = this.state.tracks.find(track => track.id === id);
    EventManager.getInstance().dispatch(events.ADD_TRACK_TO_FAVORITES, track);
    this.handleTrackFavoritePropertyUpdate(id, true);
  };

  removeFromFavorites = id => {
    const track = this.state.tracks.find(track => track.id === id);
    EventManager.getInstance().dispatch(events.REMOVE_TRACK_FROM_FAVORITES, track);
    this.handleTrackFavoritePropertyUpdate(id, false);
  };


  handleTrackFavoritePropertyUpdate = (trackId, isFavorite) => {
    this.setIsFavoritePropertyFromStateTrack(trackId, isFavorite);
    this.updateStateTracks(this.getTracksFromState());
    this.requestTrackIsFavoriteUpdate(trackId, isFavorite).catch(() => {
      this.setIsFavoritePropertyFromStateTrack(trackId, !isFavorite);
      this.updateStateTracks(this.getTracksFromState());
    });
  };

  setIsFavoritePropertyFromStateTrack = (id, value) => {
    const trackWithId = this.getSingleTrackFromStateWithId(id);

    if (trackWithId) {
      trackWithId.favorite = value
      GlobalSoundBar.setIsFavoriteFromTrackWithTitle(trackWithId.title, value);
    }
  };

  getSingleTrackFromStateWithId = trackId => this.getTracksFromState().find(track => track.id === trackId);

  getTracksFromState = () => this.state.tracks.data || this.state.tracks;

  updateStateTracks = tracks =>
    this.state.tracks.data
      ? this.setState({ tracks: { ...this.state.tracks, data: tracks } })
      : this.setState({ tracks: tracks });

  requestTrackIsFavoriteUpdate = (trackId, isFavorite) => {
    return request.contentCreationFavorite[isFavorite ? "add" : "remove"](trackId);
  };

  handleAddToPlaylistButtonPress = track => {
    this.openAddToPlaylistDialog(track);
  };

  handleRemoveFromPlaylistButtonPress = track => {
    let type = "contentCreations";
    let musicId = track.id;
    let playlistId = this.props.match.params.playlistId
    request.playlist.removeFromPlaylist({ type, playlistId, musicId })
      .then(() => {
        GlobalSnackbar.show({ message: localization.get("playlist.remove"), type: GlobalSnackbarTypes.SUCCESS });
      })
      .then(() => this.removeTrackFromList(musicId));
  };

  removeTrackFromList = musicId => {
    let tracks = this.state.tracks.filter(track => track.id !== musicId);
    this.setState({ tracks });
  };
  
  handleModalClose = () => {
    this.setState({showModal: false, selectedTrack: '', showArtist: false, speaker: '', album: '', artist: ''})
  }

  renderShowModal = () =>
    <Dialog
      disableEnforceFocus
      style={{zIndex: 999}}
      open={this.state.showModal}
      onEscapeKeyDown={this.handleModalClose}
      fullScreen={true}
    >
      {/*<Music fromHome={this.props.fromHome} musicId={this.state.selectedTrack.id} client={this.props.client} modal={true} onModalClose={this.handleModalClose} {...this.props}/>*/}
    </Dialog>

  render = () => {
    const tracks = this.state.tracks.data || this.state.tracks;
    return (
      <React.Fragment>
        {this.renderShowModal()}
        {this.openAddToGlobalPlaylistDialog()}
        {tracks.map((track, index) => (
          <>
            <div className="track-table-row">
              {!this.props.hideFavorite &&
              <div className="track-table-favorite">
                {track.favorite ? (
                  <IconButton
                    onClick={() => this.removeFromFavorites(track.id)}
                    className="track-table-remove-from-favorites-button"
                  >
                    <Star />
                  </IconButton>
                ) : (
                  <IconButton
                    className="track-table-add-to-favorites-button"
                    onClick={() => {
                      this.addToFavorites(track.id)
                    }}
                  >
                    <StarBorder />
                  </IconButton>
                )}
              </div>
              }
              <div className="track-table-image-container">
                {!this.props.hideImage ?
                  <div
                    className="track-table-image"
                    style={{backgroundImage: this.props.trackContainer ? `url(${makeImageUrlWithSize(this.props.trackContainer, 'xs')})` : `url(${noImage})`}}
                  >
                    {this.state.playing === track.id ? (
                      <IconButton onClick={this.handlePauseButtonPress} className="track-table-pause-button">
                        <Pause className="track-table-pause-icon"/>
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => this.handlePlayButtonPress(track)}
                        className="track-table-play-button"
                      >
                        <Play className="track-table-play-icon"/>
                      </IconButton>
                    )}
                  </div>
                  :
                  <div className="track-table-index" style={{color: this.props.transparentBackground && '#2b2b2b'}}>
                    <span className="track-table-index-number">{index + 1}</span>
                    {this.state.playing === track.id ? (
                      <IconButton onClick={this.handlePauseButtonPress} className="track-table-pause-button">
                        <Pause className="track-table-pause-icon"/>
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => this.handlePlayButtonPress(track)}
                        className="track-table-play-button"
                      >
                        <Play className="track-table-play-icon"/>
                      </IconButton>
                    )}
                  </div>
                }
              </div>

              <div className={"track-table-name-container"}>
                  <div
                    style={{alignSelf: track.subtitle && 'end'}}
                    className="track-table-name"
                    onClick={() => this.handlePlayButtonPress(track)}
                  >
                    {track.title}
                  </div>
                { track.contentCreator ? (
                  <React.Fragment>
                    <Link
                      style={{color: this.props.transparentBackground && '#2b2b2b'}}
                      className="track-table-name-auxiliary"
                      to={this.props.fromHome ? '#' :  homePathGenerator("contenido/" + track.contentCreator.id + "-" + track.contentCreator.name)}
                      onClick={(e) => {
                        if (this.props.fromHome) {
                          e.preventDefault()
                          this.setState({showModal: true,  contentCreator: track.contentCreator})
                          }
                        }}
                    >
                      by {track.contentCreator.name}
                    </Link>
                  </React.Fragment>
                ) : this.props.trackContainer ?
                  <Link
                    className="track-table-name-auxiliary"
                    to={this.props.fromHome ? '#' : homePathGenerator("contenido/" + this.props.trackContainer.id + "-" + this.props.trackContainer.name)}
                    onClick={() => {
                      if (this.props.fromHome) {
                          this.setState({showModal: true, contentCreator: this.props.trackContainer})
                      }
                    }}
                  >
                    {this.props.trackContainer.title}
                  </Link>
               : null}
              </div>

              <div className="track-table-sound-wave-container" style={{width: this.props.hideTags ? "35%" : "22%"}}>
                <div
                  className="track-table-sound-wave"
                  style={{
                    backgroundImage:
                      track.audio && track.audio.waveform
                        ? `url(${process.env.REACT_APP_CDN_HOST}/files/images/${track.audio.waveform.id}/crop/300x50/waveform.png)`
                        : `url(${SoundWave})`,
                  }}
                />
              </div>

              {!this.props.hideTags &&
                <div className="track-table-tags">
                  {track.tags && track.tags.length > 0 && (
                    <div style={{color: '#2b2b2b'}}>{track.tags.map(tag => tag.name).join(", ")}</div>
                  )}
                </div>
              }
              <div className="track-table-duration" style={{color: this.props.transparentBackground && 'black'}}>{track.audio ? secondsToMMSS(track.audio.duration) : "--:--"}</div>
              <div className="track-table-action-buttons">
                {!this.props.hidePlaylist && (!window.location.pathname.includes("playlist")  ?
                  <AddToPlaylist
                    id={track.id}
                    content={"contentCreations"}
                    icon={<Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                      <PlaylistAdd className={"track-table-action-icon"} style={{fontSize: 33, right: 10, cursor: "pointer", color: "black"}}/>
                    </Tooltip>}
                  />
                 : (this.props.playlistType !== 'global') ?
                  <Tooltip placement="top" title={localization.get("remove_from_playlist")}>
                    <RemoveCircle
                      onClick={() => this.handleRemoveFromPlaylistButtonPress(track)}
                      className="track-table-action-icon"
                      style={{color: this.props.transparentBackground && 'black'}}
                    />
                  </Tooltip>
                  : null)
                }
               {/* {this.state.innerWidth > 600 &&
                <Tooltip placement="top" title={localization.get('download')}>
                  <CloudDownload
                    onClick={() => this.handleDownload(track)}
                    style={{color: this.props.transparentBackground && 'black'}}
                    className="track-table-action-icon"
                  />
                </Tooltip>
                }*/}

                {this.state.innerWidth < 600 && this.state.playing === track.id &&
                   <Pause onClick={() => this.handlePauseButtonPress()} className="track-table-action-icon"/>
                }

                {this.state.innerWidth < 600 && this.state.playing !== track.id &&
                <Play
                  onClick={() => this.handlePlayButtonPress(track)}
                  className="track-table-action-icon"/>
                }
              </div>
            </div>
          </>
        ))}
        {/*{(!this.props.hideSuggestions || isNullOrUndefined(this.props.hideSuggestions)) && <Suggestions suggestions={this.state.suggestions} clientId={getActiveClient()} />}*/}
      </React.Fragment>
    );
  }
}

const Suggestions = ({ suggestions, clientId }) =>
  suggestions.length > 0 && (
    <ErrorBoundary>
      <div className="suggestions-container" >
        <h5 style={{ marginTop: 50, marginBottom: 40, textTransform: "uppercase" }} className="title bold">
          {localization.get('suggestions')}
        </h5>
        <div className="suggestion-elements-container">
          {suggestions.map(track => (
            <SuggestionElement track={track} clientId={clientId} />
          ))}
        </div>
      </div>
    </ErrorBoundary>
  );

class SuggestionElement extends Component {

  toggleFavorite = (state, trackId) => {
    return state ? request.favorite.add(trackId) : request.favorite.remove(trackId)
  }

  playSong = (track) => {
    GlobalSoundBar.loadSingleTrackAndPlay({
      fetchAudioUrl: () => new Promise(resolve => {
        let url = '';
        const date = new Date()
        const now_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

         /*
        let expiredAt = new Date(get(track, 'previewAudio.requested_at').replace(/-/g, '/'));
        expiredAt.setMilliseconds(expiredAt.getMilliseconds() + getSignatureTime())
        */
        if((now_utc - Date.parse(track.time)) < getSignatureTime()) {
          url = track.audio.url
        }else{
          url = request.contentCreation.get(track.id, "include=audio:url").then(track => track.audio.url)
        }

        resolve(url);
      }),
      id: track.id,
      title: track.title,
      subtitle: track.contentCreator.name,
      image: makeUrlImageFromAlbums(track),
      waveform: makeWaveformUrl(track),
      isFavorite: track.favorite,
      onToggleFavorite: state => this.toggleFavorite(state, track.id),
      onAddToPlaylist: () =>
          GlobalAddToPlaylistDialog.show({
            type: "contentCreation",
            selectedTrack: track,
          }),
      onSubtitleClick: () => browserHistory.push( homePathGenerator("contenido/" + track.contentCreator.id + "-" + track.contentCreator.name)),
    });
  };

  renderStateButton = () => {
    return (
      <IconButton style={{ position: "absolute", pointerEvents: "none" }} className="track-table-pause-button">
        <Play className="track-table-pause-icon" />
      </IconButton>
    );
    return null;
  };

  render = () => {
    const { track, classes } = this.props;
    return (
      <div className="suggestion-element">
        <div style={{ display: "flex" }}>
          <div className="track-suggestion-container">
            <img
              alt="suggestion"
              style={{ width: 60, height: 60 }}
              className={classes.img}
              src={makeUrlImageFromAlbums(track)}
              onClick={() => this.playSong(track)}
            />
            {this.renderStateButton()}
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "left" }}>
              <Link to={homePathGenerator("contenido/" + track.id + "-" + track.name)}>
                <Typography>{track.name}</Typography>
              </Link>
            {track.contentCreator &&
            <Link to={homePathGenerator("contenido/" + track.contentCreator.id + "-" + track.contentCreator.name)}>
              <Typography variant="caption">{track.contentCreator.name}</Typography>
            </Link>
            }
          </div>
        </div>
      </div>
    );
  };
}

SuggestionElement = withStyles({
  img: {
    width: 100,
    height: 100,
    borderRadius: 10,
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 0 5px 3px #d2d2d2",
    },
  },
})(SuggestionElement);

export default TrackTable;